export default function DashboardChart({ data, isLoading, isError }) {
  if (isLoading) return <>Loading...</>;

  if (isError)
    return (
      <>
        <div className="dashboard-chart flex-between-end">
          {/* <div
            className="white chart"
            style={{
              height: (data.data.noData / data.data.totalDevices) * 100,
            }}
          /> */}
          <div
            className="tomato chart"
            style={{
              height: 2,
            }}
          />
          <div
            className="purple chart"
            style={{
              height: 2,
            }}
          />
          <div
            className="green chart"
            style={{
              height: 2,
            }}
          />
          <div
            className="blue chart"
            style={{
              height: 2,
            }}
          />
          <div
            className="orange chart"
            style={{
              height: 2,
            }}
          />
          <div
            className="grey chart"
            style={{
              height: 2,
            }}
          />
          <div
            className="brown chart"
            style={{
              height: 2,
            }}
          />
        </div>
      </>
    );

  const calculateHeight = (count) =>
    Math.max((count / data?.data?.totalDevices) * 100, 2);

  return (
    <>
      {data?.data && (
        <div className="dashboard-chart flex-between-end">
          {/* <div
            className="white chart"
            style={{
              height: (data.data.noData / data.data.totalDevices) * 100,
            }}
          /> */}
          <div
            className="tomato chart"
            style={{
              height: calculateHeight(data?.data?.offline),
            }}
            title={`Offline: ${data?.data?.offline}`}
          />
          <div
            className="purple chart"
            style={{
              height: calculateHeight(data?.data?.unknown),
            }}
            title={`GPS not updated: ${data?.data?.unknown}`}
          />
          <div
            className="green chart"
            style={{
              height: calculateHeight(data?.data?.running),
            }}
            title={`Moving: ${data?.data?.running}`}
          />
          <div
            className="blue chart"
            style={{
              height: calculateHeight(data?.data?.online),
            }}
            title={`Online: ${data?.data?.online}`}
          />
          <div
            className="orange chart"
            style={{
              height: calculateHeight(data?.data?.idle),
            }}
            title={`Idle: ${data?.data?.idle}`}
          />
          <div
            className="grey chart"
            style={{
              height: calculateHeight(data?.data?.noData),
            }}
            title={`No data: ${data?.data?.noData}`}
          />
          <div
            className="brown chart"
            style={{
              height: calculateHeight(data?.data?.stopped),
            }}
            title={`Parking: ${data?.data?.stopped}`}
          />
        </div>
      )}
    </>
  );
}
